import { styleKeyVarMap } from './style-keys.utils.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Halts execution until SWAN styles have finished loading.
 *
 * Useful for ensuring any SWAN components have their required styles before executing a test that relies on that UI.
 *
 * @param timeout - how long to wait before rejecting the promise
 */ function waitForStyles() {
    return _waitForStyles.apply(this, arguments);
}
function _waitForStyles() {
    _waitForStyles = _async_to_generator(function*(timeout = 5000) {
        const startTime = Date.now();
        return new Promise((resolve, reject)=>{
            const checkStyles = ()=>{
                const style = getComputedStyle(document.documentElement);
                const stylesLoaded = Object.values(styleKeyVarMap).every((key)=>{
                    // Some keys don't have a corresponding CSS variables
                    if (!key) return true;
                    return style.getPropertyValue(key) === '1';
                });
                if (stylesLoaded) {
                    resolve();
                } else if (Date.now() - startTime >= timeout) {
                    const loadedStyles = Object.entries(styleKeyVarMap).reduce((acc, [key, val])=>{
                        // Some keys don't have a corresponding CSS variables
                        if (!val) {
                            return _object_spread_props(_object_spread({}, acc), {
                                [key]: true
                            });
                        }
                        return _object_spread_props(_object_spread({}, acc), {
                            [key]: style.getPropertyValue(key) === '1'
                        });
                    }, {});
                    // eslint-disable-next-line no-console
                    console.log('Loaded styles:', JSON.stringify(loadedStyles, null, 2));
                    reject(new Error('Timeout exceeded while waiting for styles to load'));
                } else {
                    setTimeout(checkStyles, 100) // Poll every 100ms
                    ;
                }
            };
            checkStyles();
        });
    });
    return _waitForStyles.apply(this, arguments);
}

export { waitForStyles };
